<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo bg-primary">
        <svg viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stop-opacity=".25" offset="0"></stop><stop stop-opacity=".1" offset=".3"></stop><stop stop-opacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlink:href="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlink:href="#a"></linearGradient></defs><path style="fill: #fff;" transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg>
      </span>
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">Bizzoft</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <!-- Dashboards -->
      <sidenav-menu icon="ion ion-md-speedometer" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Dashboards</template>
        <sidenav-router-link to="/dashboards/dashboard-1" :exact="true">Dashboard 1</sidenav-router-link>
        <sidenav-router-link to="/dashboards/qlik-test" :exact="true" v-if="hasAnyRole(['ROLE_DEVELOPER'])">
          Qlik Test
        </sidenav-router-link>
      </sidenav-menu>

      <!-- Inventarios -->
      <sidenav-menu icon="ion ion-md-cube" :active="isMenuActive('/inventory')" :open="isMenuOpen('/inventory')" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_INVENTORY', 'ROLE_POS', 'ROLE_CARRIER'])">
        <template slot="link-text">Inventario</template>
        <sidenav-router-link to="/inventory/product-list" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_INVENTORY','ROLE_POS'])">
          Productos
        </sidenav-router-link>
        <sidenav-router-link to="/inventory/inventory-operation-list" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_INVENTORY'])">
          Ajuste de Inventario
        </sidenav-router-link>
        <sidenav-router-link to="/inventory/shipping-order-list" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_INVENTORY','ROLE_POS','ROLE_CARRIER'])">
          Ordenes de Envío
        </sidenav-router-link>
      </sidenav-menu>

      <!-- Ventas -->
      <sidenav-menu icon="ion ion-md-cart" :active="isMenuActive('/sales')" :open="isMenuOpen('/sales')" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_POS'])">
        <template slot="link-text">Ventas</template>
        <sidenav-router-link to="/sales/pos" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_POS'])">Punto de Venta</sidenav-router-link>
        <sidenav-router-link to="/sales/cash-close" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_POS'])">Caja</sidenav-router-link>
        <sidenav-router-link to="/sales/sales-list" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_POS'])">Ordenes de Venta</sidenav-router-link>
        <sidenav-router-link to="/sales/customer-list" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_POS'])">Clientes</sidenav-router-link>
      </sidenav-menu>
      <!-- Reportes -->
      <sidenav-menu icon="ion ion-md-document" :active="isMenuActive('/reports')" :open="isMenuOpen('/reports')" v-if="hasAnyRole(['ROLE_ADMIN', 'ROLE_REPORTS'])">
        <template slot="link-text">Reportes</template>
        <sidenav-router-link to="/reports/inventario">Inventario</sidenav-router-link>
        <sidenav-router-link to="/reports/ventas">Ventas</sidenav-router-link>
        <sidenav-router-link to="/reports/operaciones">Operaciones Financieras</sidenav-router-link>
      </sidenav-menu>

      <!-- Configuración -->
      <sidenav-menu icon="ion ion-md-settings" :active="isMenuActive('/config')" :open="isMenuOpen('/config')" v-if="hasAnyRole(['ROLE_ADMIN'])">
        <template slot="link-text">Configuración</template>
        <sidenav-router-link to="/config/user-list" v-if="hasAnyRole(['ROLE_ADMIN','ROLE_POS'])">Usuarios</sidenav-router-link>
        <sidenav-router-link to="/config/category-list" v-if="hasAnyRole(['ROLE_ADMIN'])">Categorías</sidenav-router-link>
        <sidenav-router-link to="/config/financial-account-list" v-if="hasAnyRole(['ROLE_ADMIN'])">Cuentas Bancarias</sidenav-router-link>
        <sidenav-router-link to="/config/api-key-list" v-if="hasAnyRole(['ROLE_ADMIN'])">Llaves API</sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
